export default function setDocumentTitle(title: string) {
  document.title = title;
}
